var queuedEvents = [];
// TODO: Add tests for queue and drain
export function queueEvent(event) {
    queuedEvents.push(event);
}
export function drainQueue() {
    return queuedEvents.splice(0, queuedEvents.length);
}
//# sourceMappingURL=EventQueue.js.map